import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import SectionTitle from '../project-manage/SectionTitle';
import Question from '../project-manage/Question';

export default function QuestionsNothing(props) {
  const { project, onViewMessages } = props;

  const questions = useConnect('question.find', {
    where: {
      eager: {
        $where: {
          projectId: project.id,
          response: 'Connect',
          result: 'Nothing'
        }
      }
    },
    pagination: {
      pageSize: 100
    }
  });

  if (questions.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (questions.data.length === 0) {
    return null;
  }

  return (
    <SectionTitle
      title="Partnership Not Realized"
      subtitle="The partnership did not move forward, and no advice, connections, or support were provided."
    >
      <div className="grid grid-cols-1 gap-4">
        {questions.data.map(function (question, index) {
          return (
            <Question
              key={question.id || question.cid}
              question={question}
              onViewMessages={onViewMessages}
            />
          );
        })}
      </div>
    </SectionTitle>
  );
};
